import { useState } from 'react';
import { useLingui } from '@lingui/react/macro';

import { FiltersButton } from '@/design_system/Filters/FiltersButton/FiltersButton';
import { FiltersDrawer } from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import InputSearch from '@/design_system/InputSearch';
import Stack from '@/design_system/Stack';
import { useBrands } from '@/models/brand';
import { useCurrentOrganization } from '@/services/auth';

import { CreateAgreementButton } from '../../CreateAgreementButton';
import { useFilters } from '../FiltersState';

import { MobileFiltersAgreementType } from './MobileFiltersAgreementType';
import { MobileFiltersArticleBrand } from './MobileFiltersArticleBrand';
import { MobileFiltersArticleWorkshop } from './MobileFiltersArticleWorkshop';
import { MobileFiltersEntityOrGroup } from './MobileFiltersEntityOrGroup';
import { MobileFiltersHasClient } from './MobileFiltersHasClient';

export const MobileFilters = () => {
  const { t } = useLingui();
  const [isOpen, setIsOpen] = useState(false);
  const { search, activeFiltersCount, clearFilters } = useFilters();
  const [organization] = useCurrentOrganization();

  const { data: brandsData } = useBrands({
    organizationId: organization?.id,
    limit: 500,
    offset: 0,
  });

  const showBrandFilter = !!brandsData?.brands && brandsData.brands.length > 1;

  return (
    <Stack row gap="1rem" alignItems="center">
      <InputSearch
        ariaLabel={t({
          id: 'settings.organization.entities.agreements.search.label',
          message: 'Search agreements',
        })}
        placeholder={t({
          id: 'settings.organization.entities.agreements.search.placeholder',
          message: 'Search by entity or group name…',
        })}
        value={search.search}
        onChange={search.debouncedSetSearch}
        style={{ flex: 1 }}
      />
      <CreateAgreementButton />
      <FiltersDrawer
        button={<FiltersButton count={activeFiltersCount} onClick={() => setIsOpen(true)} />}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        onClearFilters={activeFiltersCount ? clearFilters : undefined}
      >
        <MobileFiltersAgreementType />
        <MobileFiltersEntityOrGroup />
        <MobileFiltersHasClient />
        {showBrandFilter ? <MobileFiltersArticleBrand /> : null}
        <MobileFiltersArticleWorkshop />
      </FiltersDrawer>
    </Stack>
  );
};
